import {CSSProperties, ReactNode} from "react";
import {TextSize} from "@web-libs/ui/ui-components/typo/types";
import cssStyles from "./headline.module.css"
import {mergeClassNames} from "@web-libs/util/class-names/class-names";

export type HeaderProps = {
    children: ReactNode,
    size: TextSize
    style?: CSSProperties,
    className?: string
}

const SizeTable: {[key in TextSize] : number} = {
    xs: 24,
    sm: 30,
    md: 40,
    lg: 64
}

const ClassTable: {[key in TextSize] : string} = {
    xs: cssStyles.xs,
    sm: cssStyles.sm,
    md: cssStyles.md,
    lg: cssStyles.lg
}

const TagTable: {[key in TextSize] : string} = {
    xs: "h4",
    sm: "h3",
    md: "h2",
    lg: "h1"
}

export const Headline = ({children, style, size, className}: HeaderProps) => {

    const _style = {
        fontWeight: 600,
        lineHeight: 1,
        ...style
    }

    const classTable = ClassTable[size]

    const Tag = TagTable[size] as keyof JSX.IntrinsicElements

    return (
        <Tag className={mergeClassNames(cssStyles.tageaHeadline,className,classTable)} style={_style}>
            {children}
        </Tag>
    )
}
